import React from "react";

import type { TextProps } from "@/compat/radix-themes";
import { Text } from "@/compat/radix-themes";

type TextLabelProps = TextProps & {
  children?: React.ReactNode;
  className?: string;
  size?: TextProps["size"]; // e.g., "1" | "2" | "3" etc.
  require?: boolean;
  htmlFor?: string;
};

const TextLabel = ({
  size = "1",
  className = "",
  children,
  require,
  ...rest
}: TextLabelProps) => {
  return (
    <Text
      size={size}
      className={`typo-label text-text-primary ${className}`}
      {...rest}
    >
      {children} {require && <span className="text-red-500">*</span>}
    </Text>
  );
};

export default TextLabel;
